module.exports = {
          srcSet: "/_next/static/images/logo_white-512-c61671abda245782630408d63e43a077.png"+" 512w",
          images:[ {path: "/_next/static/images/logo_white-512-c61671abda245782630408d63e43a077.png",width: 512,height: 169}],
          src: "/_next/static/images/logo_white-512-c61671abda245782630408d63e43a077.png",
          toString:function(){return "/_next/static/images/logo_white-512-c61671abda245782630408d63e43a077.png"},
          
          width: 512,
          height: 169
        }